import { useEffect, useState } from 'react'

import { api } from '../api'
import { t } from '../i18n'
import { openExternal } from '../telegram'
import type { Deal } from '../types'

export const DEAL_ICON: Record<string, string> = {
  palas: '🎾',
  zapatillas: '👟',
  pelotas: '🟡',
  ropa: '👕',
  accesorios: '🎒',
}

function euro(value: number): string {
  return `${value.toFixed(2).replace(/\.00$/, '').replace('.', ',')} €`
}

/** Тестовая полоса скидок в ленте. Ссылки могут быть партнёрскими, поэтому
 *  полоса всегда подписана — это реклама, и человек должен это видеть. */
export default function DealsStrip() {
  const [deals, setDeals] = useState<Deal[]>([])

  useEffect(() => {
    api.deals().then(setDeals, () => setDeals([]))
  }, [])

  if (deals.length === 0) return null

  function open(deal: Deal) {
    // Сначала открываем: в Telegram ссылку нужно открыть прямо по нажатию
    openExternal(deal.url)
    void api.clickDeal(deal.id).catch(() => undefined)
  }

  return (
    <section className="deals" aria-label={t().dealsTitle}>
      <div className="deals-head">
        <span className="title">🏷 {t().dealsTitle}</span>
        <span className="muted small">{t().dealsAd}</span>
      </div>
      <div className="deals-rail">
        {deals.map((deal) => (
          <button key={deal.id} className="deal" onClick={() => open(deal)}>
            <span className="deal-img">
              {deal.image_url ? (
                <img
                  src={deal.image_url}
                  alt=""
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  onError={(e) => {
                    e.currentTarget.replaceWith(document.createTextNode(DEAL_ICON[deal.category] ?? '🎾'))
                  }}
                />
              ) : (
                DEAL_ICON[deal.category] ?? '🎾'
              )}
              {deal.discount != null && <span className="deal-off">−{deal.discount}%</span>}
            </span>
            <span className="deal-title">{deal.title}</span>
            <span className="deal-price">
              <b>{euro(deal.price)}</b>
              {deal.old_price != null && <s>{euro(deal.old_price)}</s>}
            </span>
            <span className="deal-shop">{deal.shop}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
